// extracted by mini-css-extract-plugin
export default {"profile":"styles_profile__4ywW9","form":"styles_form__A26kI","application":"styles_application__f1IoS","cardBox":"styles_cardBox__xY7qk","cardContent":"styles_cardContent__Bn4gl"};